/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-home"}[chunkId]||chunkId) + ".chunk." + {"0":"3f464"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/LoQ":
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":" e ","unitSeparator":"e ","andWhenTrailing":true,"base":{"0":"zero","1":"um","2":"dois","3":"três","4":"quatro","5":"cinco","6":"seis","7":"sete","8":"oito","9":"nove","10":"dez","11":"onze","12":"doze","13":"treze","14":"catorze","15":"quinze","16":"dezasseis","17":"dezassete","18":"dezoito","19":"dezanove","20":"vinte","30":"trinta","40":"quarenta","50":"cinquenta","60":"sessenta","70":"setenta","80":"oitenta","90":"noventa","100":"cem","200":"duzentos","300":"trezentos","400":"quatrocentos","500":"quinhentos","600":"seiscentos","700":"setecentos","800":"oitocentos","900":"novecentos","1000":"mil"},"unitExceptions":{"1":"um"},"units":[{"singular":"cento","useBaseInstead":true,"useBaseException":[1],"useBaseExceptionWhenNoTrailingNumbers":true,"andException":true},{"singular":"mil","avoidPrefixException":[1],"andException":true},{"singular":"milhão","plural":"milhões"},{"singular":"bilião","plural":"biliões"},{"singular":"trilião","plural":"triliões"},{"singular":"quadrilião","plural":"quadriliões"},{"singular":"quintilião","plural":"quintiliões"},{"singular":"sextilião","plural":"sextiliões"},{"singular":"septilião","plural":"septiliões"},{"singular":"octilião","plural":"octiliões"},{"singular":"nonilião","plural":"noniliões"},{"singular":"decilião","plural":"deciliões"}]}

/***/ }),

/***/ "0fPy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = writtenNumber;
var util = __webpack_require__("3FiR");

var languages = ["en", "es", "ar", "pt", "fr", "eo", "it", "vi", "tr", "uk", "id"];
var i18n = {
  en: __webpack_require__("QbsE"),
  es: __webpack_require__("ZNW6"),
  ar: __webpack_require__("5BUW"),
  pt: __webpack_require__("Oase"),
  ptPT: __webpack_require__("/LoQ"),
  fr: __webpack_require__("N0i4"),
  eo: __webpack_require__("iSAk"),
  it: __webpack_require__("XJYd"),
  vi: __webpack_require__("i6oV"),
  tr: __webpack_require__("I1T5"),
  hu: __webpack_require__("Lwtw"),
  enIndian: __webpack_require__("cF+q"),
  uk: __webpack_require__("aQQq"),
  id: __webpack_require__("IK6j")
};
exports.i18n = i18n;

var shortScale = [100];
for (var i = 1; i <= 16; i++) {
  shortScale.push(Math.pow(10, i * 3));
}

var longScale = [100, 1000];
for (i = 1; i <= 15; i++) {
  longScale.push(Math.pow(10, i * 6));
}

writtenNumber.defaults = {
  noAnd: false,
  alternativeBase: null,
  lang: "en"
};

/**
 * Converts numbers to their written form.
 *
 * @param {Number} n The number to convert
 * @param {Object} [options] An object representation of the options
 * @return {String} writtenN The written form of `n`
 */

function writtenNumber(n, options) {
  options = options || {};
  options = util.defaults(options, writtenNumber.defaults);

  if (n < 0) {
    return "";
  }

  n = Math.round(+n);

  var language = typeof options.lang === "string" ? i18n[options.lang] : options.lang;

  if (!language) {
    if (languages.indexOf(writtenNumber.defaults.lang) < 0) {
      writtenNumber.defaults.lang = "en";
    }

    language = i18n[writtenNumber.defaults.lang];
  }

  var scale = language.useLongScale ? longScale : shortScale;
  var units = language.units;
  var unit;

  if (!(units instanceof Array)) {
    var rawUnits = units;

    units = [];
    scale = Object.keys(rawUnits);

    for (var i in scale) {
      units.push(rawUnits[scale[i]]);
      scale[i] = Math.pow(10, parseInt(scale[i]));
    }
  }

  var baseCardinals = language.base;
  var alternativeBaseCardinals = options.alternativeBase ? language.alternativeBase[options.alternativeBase] : {};

  if (language.unitExceptions[n]) return language.unitExceptions[n];
  if (alternativeBaseCardinals[n]) return alternativeBaseCardinals[n];
  if (baseCardinals[n]) return baseCardinals[n];
  if (n < 100) return handleSmallerThan100(n, language, unit, baseCardinals, alternativeBaseCardinals, options);

  var m = n % 100;
  var ret = [];

  if (m) {
    if (options.noAnd && !(language.andException && language.andException[10])) {
      ret.push(writtenNumber(m, options));
    } else {
      ret.push(language.unitSeparator + writtenNumber(m, options));
    }
  }

  var firstSignificant;

  for (var i = 0, len = units.length; i < len; i++) {
    var r = Math.floor(n / scale[i]);
    var divideBy;

    if (i === len - 1) divideBy = 1000000;else divideBy = scale[i + 1] / scale[i];

    r %= divideBy;

    unit = units[i];

    if (!r) continue;
    firstSignificant = scale[i];

    if (unit.useBaseInstead) {
      var shouldUseBaseException = unit.useBaseException.indexOf(r) > -1 && (unit.useBaseExceptionWhenNoTrailingNumbers ? i === 0 && ret.length : true);
      if (!shouldUseBaseException) {
        ret.push(alternativeBaseCardinals[r * scale[i]] || baseCardinals[r * scale[i]]);
      } else {
        ret.push(r > 1 && unit.plural ? unit.plural : unit.singular);
      }
      continue;
    }

    var str;
    if (typeof unit === "string") {
      str = unit;
    } else if (r === 1 || unit.useSingularEnding && r % 10 === 1 && (!unit.avoidEndingRules || unit.avoidEndingRules.indexOf(r) < 0)) {
      str = unit.singular;
    } else if (unit.few && (r > 1 && r < 5 || unit.useFewEnding && r % 10 > 1 && r % 10 < 5 && (!unit.avoidEndingRules || unit.avoidEndingRules.indexOf(r) < 0))) {
      str = unit.few;
    } else {
      str = unit.plural && (!unit.avoidInNumberPlural || !m) ? unit.plural : unit.singular;

      // Languages with dual
      str = r === 2 && unit.dual ? unit.dual : str;

      // "restrictedPlural" : use plural only for 3 to 10
      str = r > 10 && unit.restrictedPlural ? unit.singular : str;
    }

    if (unit.avoidPrefixException && unit.avoidPrefixException.indexOf(r) > -1) {
      ret.push(str);
      continue;
    }

    var exception = language.unitExceptions[r];
    var number = exception || writtenNumber(r, util.defaults({
      // Languages with and exceptions need to set `noAnd` to false
      noAnd: !(language.andException && language.andException[r] || unit.andException) && true,
      alternativeBase: unit.useAlternativeBase
    }, options));
    n -= r * scale[i];
    ret.push(number + " " + str);
  }

  var firstSignificantN = firstSignificant * Math.floor(n / firstSignificant);
  var rest = n - firstSignificantN;

  if (language.andWhenTrailing && firstSignificant && 0 < rest && ret[0].indexOf(language.unitSeparator) !== 0) {
    ret = [ret[0], language.unitSeparator.replace(/\s+$/, "")].concat(ret.slice(1));
  }

  // Languages that have separators for all cardinals.
  if (language.allSeparator) {
    for (var j = 0; j < ret.length - 1; j++) {
      ret[j] = language.allSeparator + ret[j];
    }
  }
  var result = ret.reverse().join(" ");
  return result;
}

function handleSmallerThan100(n, language, unit, baseCardinals, alternativeBaseCardinals, options) {
  var dec = Math.floor(n / 10) * 10;
  unit = n - dec;
  if (unit) {
    return alternativeBaseCardinals[dec] || baseCardinals[dec] + language.baseSeparator + writtenNumber(unit, options);
  }
  return alternativeBaseCardinals[dec] || baseCardinals[dec];
}

/***/ }),

/***/ "2P4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ES */
/* unused harmony export EN */
/* unused harmony export numberToWords */
/* unused harmony export fiatToWords */
/* harmony export (immutable) */ __webpack_exports__["a"] = btcToWords;
/* harmony export (immutable) */ __webpack_exports__["b"] = setLang;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bitcoin_math__ = __webpack_require__("61Nj");
var writtenNumber = __webpack_require__("0fPy");


var ES = 'es';
var EN = 'en';

var LANG = ES;

function numberToWords(amount) {
  var lang = LANG;
  amount = amount && amount !== Infinity ? amount : 0;
  var whole = amount >= 1 ? Number.parseInt(amount) : 0;

  var text = '';

  if (amount == 1 && lang == ES) {
    return 'un dolar';
  }

  if (whole) {
    text = writtenNumber(whole, { lang: lang });
  }

  var cents = (amount - whole).toFixed(2) * 100;
  if (cents) {
    var centsText = 'point ' + writtenNumber(cents, { lang: lang });

    if (text) {
      return text + ' ' + centsText;
    }

    return centsText;
  }

  return text;
}

function fiatToWords(amount) {
  var lang = LANG;

  var centsText = void 0;var dollarText = void 0;var dollarsText = void 0;
  switch (lang) {
    case EN:
      dollarText = 'dollar';
      dollarsText = 'dollars';
      centsText = 'cents';
      break;
    case ES:
    default:
      if (amount === 1) {
        return 'un dolar';
      }
      dollarText = 'dolar';
      dollarsText = 'dolares';
      centsText = 'centavos';
      break;
  }

  amount = amount && amount !== Infinity ? amount : 0;
  var whole = amount >= 1 ? Number.parseInt(amount) : 0;

  var text = void 0;
  if (whole) {
    var currText = whole === 1 ? dollarText : dollarsText;
    text = writtenNumber(whole, { lang: lang }) + ' ' + currText;
  }

  var cents = (amount - whole).toFixed(2) * 100;
  if (!cents) {
    return text;
  }

  centsText = writtenNumber(cents, { lang: lang }) + ' ' + centsText;

  if (text) {
    return text + ' and ' + centsText;
  }

  return centsText;
}

function btcToWords(amount) {
  var lang = LANG;
  amount = amount.toFixed(8);

  var _getSats = Object(__WEBPACK_IMPORTED_MODULE_0__bitcoin_math__["a" /* getSats */])(amount),
      btc = _getSats.btc,
      sats = _getSats.sats;

  var text = void 0;
  if (btc) {
    var currText = btc === 1 ? 'bitcoin' : 'bitcoins';
    text = writtenNumber(btc, { lang: lang }) + ' ' + currText;
  }

  if (sats) {
    var satsCurrText = sats === 1 ? 'satoshi' : 'satoshis';
    var satsText = writtenNumber(sats, { lang: lang }) + ' ' + satsCurrText;

    if (text) {
      return text + ' and ' + satsText;
    }

    return satsText;
  }

  return text;
}

function setLang(lang) {
  lang = lang ? lang : ES;
  console.log('default lang:', lang);
  LANG = lang;
}

/***/ }),

/***/ "3FiR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Merges a set of default keys with a target object
 * (Like _.defaults, but will also extend onto null/undefined)
 *
 * @param {Object} [target] The object to extend
 * @param {Object} defaults The object to default to
 * @return {Object} extendedTarget
 */

function defaults(target, defs) {
  if (target == null) target = {};
  var ret = {};
  var keys = Object.keys(defs);
  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];
    ret[key] = target[key] || defs[key];
  }
  return ret;
}
exports.defaults = defaults;

/***/ }),

/***/ "4N50":
/***/ (function(module, exports) {

module.exports = {"amount":"cantidad","mined-gold":"oro minado","millionaire-average":"acciones por multimillonario","percenter-wealth":"acciones por 0.1-percenter","intro":{"line-1":"Te has preguntado si alguna vez poseeras un poco de bitcoin?","line-2":"Los más seguro es que puedes adquirir un poco de bitcoin.","line-4":"A las fracciones de un bitcoin se les llama satoshis.","explain-satoshis":"Un bitcoin es igual a cien millones de satoshis."},"world":{"title":"Para cada persona","intro":"Cuanto Bitcoin recibirías si se repartiera a todas las personas del mundo?","adult-population":"población adulta","bitcoin-supply":"suministro de bitcoin","bitcoin-for-each-person":"bitcoin para cada persona","satoshis-for-each-person":"satoshis para cada persona"},"cash":{"title":"Efectivo","could-buy-me":"me podrían comprar","description":"¿Cuánto bitcoin me embolso por este efectivo?"},"bitcoin":{"individual-world-share":"acciones por adulto"},"supply":{"title":"Suministro","supply-percentage":"Comparación de Suministros","bitcoin-equivalent":"proporcional en btc","broad-money":"Dinero en la economía","millionaire-median":"Media de los Millonarios","millionaire-average":"Millonario Promedio","billionaire-average":"Billonario Promedio","percenter-median":"Media del 1%"},"bitcoin-stats":{"total-adults":"Adultos","total-wealth":"Riqueza total","total-supply":"Suministro total","lost-estimate":"Perdida estimada","remaining-supply":"Suministro restante","one-bitcoin":"Un Bitcoin","100M-sats":"Cien millones de Satoshis"},"wealth-pyramid":{"title":"Wealth Pyramid","global-wealth":"Riqueza Global"}}

/***/ }),

/***/ "5BUW":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"","unitSeparator":"","allSeparator":"و","base":{"0":"صفر","1":"واحد","2":"اثنان","3":"ثلاثة","4":"أربعة","5":"خمسة","6":"ستة","7":"سبعة","8":"ثمانية","9":"تسعة","10":"عشرة","11":"أحد عشر","12":"إثنا عشر","13":"ثلاثة عشر","14":"أربعة عشر","15":"خمسة عشر","16":"ستة عشر","17":"سبعة عشر","18":"ثمانية عشر","19":"تسعة عشر","20":"عشرون","21":"واحد وعشرون","22":"اثنان وعشرون","23":"ثلاثة وعشرون","24":"أربعة وعشرون","25":"خمسة وعشرون","26":"ستة وعشرون","27":"سبعة وعشرون","28":"ثمانية وعشرون","29":"تسعة وعشرون","30":"ثلاثون","31":"واحد وثلاثون","32":"اثنان وثلاثون","33":"ثلاثة وثلاثون","34":"أربعة وثلاثون","35":"خمسة وثلاثون","36":"ستة وثلاثون","37":"سبعة وثلاثون","38":"ثمانية وثلاثون","39":"تسعة وثلاثون","40":"أربعون","41":"واحد وأربعون","42":"اثنان وأربعون","43":"ثلاثة وأربعون","44":"أربعة وأربعون","45":"خمسة وأربعون","46":"ستة وأربعون","47":"سبعة وأربعون","48":"ثمانية وأربعون","49":"تسعة وأربعون","50":"خمسون","51":"واحد وخمسون","52":"اثنان وخمسون","53":"ثلاثة وخمسون","54":"أربعة وخمسون","55":"خمسة وخمسون","56":"ستة وخمسون","57":"سبعة وخمسون","58":"ثمانية وخمسون","59":"تسعة وخمسون","60":"ستون","61":"واحد وستون","62":"اثنان وستون","63":"ثلاثة وستون","64":"أربعة وستون","65":"خمسة وستون","66":"ستة وستون","67":"سبعة وستون","68":"ثمانية وستون","69":"تسعة وستون","70":"سبعون","71":"واحد وسبعون","72":"اثنان وسبعون","73":"ثلاثة وسبعون","74":"أربعة وسبعون","75":"خمسة وسبعون","76":"ستة وسبعون","77":"سبعة وسبعون","78":"ثمانية وسبعون","79":"تسعة وسبعون","80":"ثمانون","81":"واحد وثمانون","82":"اثنان وثمانون","83":"ثلاثة وثمانون","84":"أربعة وثمانون","85":"خمسة وثمانون","86":"ستة وثمانون","87":"سبعة وثمانون","88":"ثمانية وثمانون","89":"تسعة وثمانون","90":"تسعون","91":"واحد وتسعون","92":"اثنان وتسعون","93":"ثلاثة وتسعون","94":"أربعة وتسعون","95":"خمسة وتسعون","96":"ستة وتسعون","97":"سبعة وتسعون","98":"ثمانية وتسعون","99":"تسعة وتسعون","200":"مائتان","300":"ثلاثمائة","400":"أربعمائة","500":"خمسمائة","600":"ستمائة","700":"سبعمائة","800":"ثمانمائة","900":"تسعمائة"},"units":[{"singular":"مائة","useBaseInstead":true,"useBaseException":[1]},{"singular":"ألف","dual":"ألفان","plural":"آلاف","restrictedPlural":true,"avoidPrefixException":[1,2]},{"singular":"مليون","dual":"مليونان","plural":"ملايين","restrictedPlural":true,"avoidPrefixException":[1,2]},{"singular":"مليار","dual":"ملياران","plural":"ملايير","restrictedPlural":true,"avoidPrefixException":[1,2]},{"singular":"تريليون","avoidPrefixException":[1]},{"singular":"كوادريليون","avoidPrefixException":[1]},{"singular":"كوينتليون","avoidPrefixException":[1]},{"singular":"سكستليون","avoidPrefixException":[1]},{"singular":"سبتيلليون","avoidPrefixException":[1]},{"singular":"أوكتيليون","avoidPrefixException":[1]},{"singular":"نونيلليون","avoidPrefixException":[1]},{"singular":"دشيليون","avoidPrefixException":[1]},{"singular":"أوندشيلليون","avoidPrefixException":[1]},{"singular":"دودشيليون","avoidPrefixException":[1]},{"singular":"تريدشيليون","avoidPrefixException":[1]},{"singular":"كواتوردشيليون","avoidPrefixException":[1]},{"singular":"كويندشيليون","avoidPrefixException":[1]}],"unitExceptions":{}}

/***/ }),

/***/ "61Nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TO_FIXED_MAX */
/* unused harmony export truncate */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseBitcoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSats;

// 1 Bitcoin (BTC) = 100,000,000 Satoshis
var ONE_HUNDRED_MILLION = 100000000;
var ONE_SAT = 0.00000001;
var TO_FIXED_MAX = 100;

function truncate(number, decimalsPrecison) {
  var numStr = number.toFixed(TO_FIXED_MAX);

  var dotIndex = numStr.indexOf('.');
  numStr = numStr.substring(0, dotIndex + decimalsPrecison + 1);

  return Number.parseFloat(numStr);
}

function parseBitcoin(number) {
  var satPrecision = 8;

  if (number >= ONE_SAT) {
    var numStr = number.toFixed(satPrecision);
    return Number.parseFloat(numStr);
  }

  return truncate(number, satPrecision);
}

function getSats(amount) {
  amount = amount && amount !== Infinity ? amount : 0;
  var whole = ~~amount;

  var sats = amount - whole;
  if (sats < ONE_SAT) {
    sats = 0;
    return { btc: whole, sats: sats };
  }

  sats = sats * ONE_HUNDRED_MILLION;
  sats += Number.EPSILON;
  sats = sats.toPrecision(8);
  sats = Number.parseInt(sats);

  return { btc: whole, sats: sats };
}

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "BA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = internalNavigate;
/* unused harmony export buildSearchString */
/* harmony export (immutable) */ __webpack_exports__["d"] = scheduleHistoryPushState;
/* unused harmony export readQueryParams */
/* unused harmony export scrollTo */
/* harmony export (immutable) */ __webpack_exports__["a"] = deconstructWindowLocation;
/* unused harmony export deconstructHref */
/* harmony export (immutable) */ __webpack_exports__["c"] = listenForDataNavigateClicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__words__ = __webpack_require__("2P4X");


function internalNavigate(_ref) {
  var btc = _ref.btc,
      fiat = _ref.fiat,
      loc = _ref.loc,
      hash = _ref.hash;

  Object(__WEBPACK_IMPORTED_MODULE_0__words__["b" /* setLang */])(loc);
  scheduleHistoryPushState({ btc: btc, fiat: fiat, loc: loc }, hash);
}

function buildSearchString(btc, fiat, loc) {
  var search = '';

  if (btc) {
    search += 'btc=' + btc;
  }

  if (fiat) {
    search += search ? '&' : '';
    search += 'fiat=' + fiat;
  }

  if (loc) {
    search += search ? '&' : '';
    search += 'loc=' + loc;
  }

  return search;
}

function historyPushState(_ref2, hash) {
  var btc = _ref2.btc,
      fiat = _ref2.fiat,
      loc = _ref2.loc;

  var scrollToHash = true;
  if (!hash) {
    hash = window.location.hash;
    scrollToHash = false;
  }

  var search = buildSearchString(btc, fiat, loc);

  var title = '\u20BF' + btc + ' & $' + fiat;

  var url = search ? '?' + search : '';

  if (hash) {
    url += hash;
  }

  window.history.pushState({ btc: btc, fiat: fiat, loc: loc }, title, url);

  // Don't scroll if we are just preserving an existing hash
  // Scroll only if a hash has been passed in explicitly, 
  // the assumption is that explicit user action caused it.
  if (scrollToHash) {
    scrollTo(hash);
  }
}

var timer = null;

function scheduleHistoryPushState(search, hash) {
  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(function () {
    historyPushState(search, hash);
    timer = null;
  }, 100);
}

function readQueryParams(search) {
  var btc = search.match(/btc=(\d*[.]?\d*)/);
  btc = btc && btc[1] ? Number.parseFloat(btc[1]) : 0;

  var fiat = search.match(/fiat=(\d*[.]?\d*)/);
  fiat = fiat && fiat[1] ? Number.parseFloat(fiat[1]) : 0;

  var loc = search.match(/loc=([a-z]{2})/);
  loc = loc && loc[1] ? loc[1] : null;

  return { btc: btc, fiat: fiat, loc: loc };
}

function scrollTo(query) {
  if (!query) {
    return;
  }

  var el = document.querySelector(query);

  if (!el) {
    console.error('could not find: ' + query);
    return;
  }

  el.scrollIntoView({
    behavior: 'smooth'
  });
}

function deconstructWindowLocation(location) {
  location = location ? location : window.location;

  var _readQueryParams = readQueryParams(location.search),
      btc = _readQueryParams.btc,
      fiat = _readQueryParams.fiat,
      loc = _readQueryParams.loc;

  var hash = location.hash;

  return { btc: btc, fiat: fiat, loc: loc, hash: hash };
}

function deconstructHref(href) {
  var _readQueryParams2 = readQueryParams(href),
      btc = _readQueryParams2.btc,
      fiat = _readQueryParams2.fiat,
      loc = _readQueryParams2.loc;

  btc = btc ? btc : 0;
  fiat = fiat ? fiat : 0;

  var hashIndex = href.indexOf('#');
  var hash = void 0;
  if (hashIndex) {
    hash = href.substring(hashIndex);
  }

  return { btc: btc, fiat: fiat, loc: loc, hash: hash };
}

function listenForDataNavigateClicks(callback) {
  if (typeof window !== 'undefined') {
    window.document.addEventListener('click', function (event) {
      var target = event.target;

      do {

        if (target.tagName === 'A' && target.dataset.navigate !== undefined) {
          event.preventDefault();

          var href = target.href;
          var obj = deconstructHref(href);
          callback(obj);

          return false;
        }

        target = target.parentElement;
      } while (target.tagName !== 'BODY');
    });
  }
}

/***/ }),

/***/ "CYb7":
/***/ (function(module, exports, __webpack_require__) {

!function (t, n) {
   true ? module.exports = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }return t === o ? e : t;
  } : "function" == typeof define && define.amd ? define(function () {
    return function (t, n, e, i, o) {
      for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
        t = t ? t[n[i]] : o;
      }return t === o ? e : t;
    };
  }) : t.dlv = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }return t === o ? e : t;
  };
}(this);
//# sourceMappingURL=dlv.umd.js.map

/***/ }),

/***/ "I1T5":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"sıfır","1":"bir","2":"iki","3":"üç","4":"dört","5":"beş","6":"altı","7":"yedi","8":"sekiz","9":"dokuz","10":"on","20":"yirmi","30":"otuz","40":"kırk","50":"elli","60":"altmış","70":"yetmiş","80":"seksen","90":"doksan"},"units":[{"singular":"yüz","avoidPrefixException":[1]},{"singular":"bin","avoidPrefixException":[1]},"milyon","milyar","trilyon","katrilyon","kentilyon","sekstilyon","septilyon","oktilyon","nonilyon","desilyon","andesilyon","dodesilyon","tredesilyon","katordesilyon","kendesilyon"],"unitExceptions":[]}

/***/ }),

/***/ "IK6j":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"nol","1":"satu","2":"dua","3":"tiga","4":"empat","5":"lima","6":"enam","7":"tujuh","8":"delapan","9":"sembilan","10":"sepuluh","11":"sebelas","12":"dua belas","13":"tiga belas","14":"empat belas","15":"lima belas","16":"enam belas","17":"tujuh belas","18":"delapan belas","19":"sembilan belas","20":"dua puluh","30":"tiga puluh","40":"empat puluh","50":"lima puluh","60":"enam puluh","70":"tujuh puluh","80":"delapan puluh","90":"sembilan puluh"},"units":[{"singular":"seratus","plural":"ratus","avoidPrefixException":[1]},{"singular":"seribu","plural":"ribu","avoidPrefixException":[1]},"juta","miliar","triliun","kuadiliun"],"unitExceptions":[]}

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-i18n/dist/preact-i18n.esm.js
var preact_i18n_esm = __webpack_require__("rNh1");

// EXTERNAL MODULE: ./i18n/en-us.json
var en_us = __webpack_require__("qqRS");
var en_us_default = /*#__PURE__*/__webpack_require__.n(en_us);

// EXTERNAL MODULE: ./i18n/es-mx.json
var es_mx = __webpack_require__("4N50");
var es_mx_default = /*#__PURE__*/__webpack_require__.n(es_mx);

// EXTERNAL MODULE: ./utils/words.js
var words = __webpack_require__("2P4X");

// CONCATENATED MODULE: ./utils/fetch-prices.js
var host =  false ? 'http://localhost:8888/.netlify/functions' : 'https://btc.gratis/.netlify/functions';
var url = host + '/btc-usd/btc-usd';
// debug line
//const url = 'https://btc-scarcity.netlify.com/.netlify/functions/btc-usd/btc-usd';

function fetch_prices_fetchPrices() {
  var fetchOptions = {
    method: 'GET',
    mode: 'cors',
    headers: {
      accept: 'application/json'
    }
  };

  return fetch(url, fetchOptions).then(function (response) {
    if (!response.ok) {
      // TODO: 502 although the response is correct
    }

    return response.json();
  });
}
// EXTERNAL MODULE: ./utils/router.js
var router = __webpack_require__("BA51");

// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./components/app.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Code-splitting is automated for routes


var app_App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      btcHodl: 0,
      btcPrice: 0,
      goldPrice: 0,
      fiatPurchase: 0,
      loc: 'es'
    };

    _this.handleRoute = function (e) {
      _this.currentUrl = e.url;
    };

    if (typeof window !== 'undefined') {
      window.onpopstate = function (event) {
        if (!event.state) {
          return;
        }

        var _event$state = event.state,
            btc = _event$state.btc,
            fiat = _event$state.fiat,
            loc = _event$state.loc;

        _this.setState({
          btcHodl: btc,
          fiatPurchase: fiat,
          loc: loc
        });
      };
    }

    Object(router["c" /* listenForDataNavigateClicks */])(function (locationState) {
      locationState.loc = locationState.loc ? locationState.loc : _this.state.loc;
      _this.setStateFromLocation(locationState);
      Object(router["b" /* internalNavigate */])(locationState);
    });
    return _this;
  }

  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */


  App.prototype.updateLocale = function updateLocale(loc) {
    Object(words["b" /* setLang */])(loc);

    this.setState(function (state) {
      var newState = _extends({}, state);
      newState.loc = loc;

      Object(router["d" /* scheduleHistoryPushState */])({
        btc: newState.btcHodl,
        fiat: newState.fiatPurchase,
        loc: newState.loc
      });

      return newState;
    });
  };

  App.prototype.updateBtcHodl = function updateBtcHodl(btcAmount) {
    this.setState(function (state, props) {
      var newState = _extends({}, state);
      newState.btcHodl = btcAmount;

      Object(router["d" /* scheduleHistoryPushState */])({
        btc: newState.btcHodl,
        fiat: newState.fiatPurchase,
        loc: newState.loc
      });

      return newState;
    });
  };

  App.prototype.updateFiatPurchase = function updateFiatPurchase(fiatAmount) {
    this.setState(function (state, props) {
      var newState = _extends({}, state);
      newState.fiatPurchase = fiatAmount;

      Object(router["d" /* scheduleHistoryPushState */])({
        btc: newState.btcHodl,
        fiat: newState.fiatPurchase,
        loc: newState.loc
      });

      return newState;
    });
  };

  App.prototype.updatePrices = function updatePrices(btcPrice, goldPrice) {
    this.setState(function (state, props) {
      var newState = _extends({}, state);
      newState.btcPrice = btcPrice;
      newState.goldPrice = goldPrice;
      return newState;
    });
  };

  App.prototype.setStateFromLocation = function setStateFromLocation(_ref) {
    var btc = _ref.btc,
        fiat = _ref.fiat,
        loc = _ref.loc;

    this.setState({ btcHodl: btc, fiatPurchase: fiat, loc: loc });
  };

  App.prototype.fetchPrices = function fetchPrices() {
    var _this2 = this;

    fetch_prices_fetchPrices().then(function (_ref2) {
      var btcPrice = _ref2.btcPrice,
          goldPrice = _ref2.goldPrice;

      _this2.updatePrices(btcPrice, goldPrice);
    }).catch(function (error) {
      console.error(error);
    });
  };

  App.prototype.startPricePolling = function startPricePolling() {
    var _this3 = this;

    this.fetchPrices();

    var oneMinute = 1000 * 60;
    var minutes = oneMinute * 10;
    setInterval(function () {
      _this3.fetchPrices();
    }, minutes);
  };

  App.prototype.componentDidMount = function componentDidMount() {
    this.startPricePolling();

    var locationState = Object(router["a" /* deconstructWindowLocation */])();
    this.setStateFromLocation(locationState);
  };

  App.prototype.render = function render() {
    var _this4 = this;

    var _state = this.state,
        btcHodl = _state.btcHodl,
        btcPrice = _state.btcPrice,
        goldPrice = _state.goldPrice,
        fiatPurchase = _state.fiatPurchase,
        loc = _state.loc;


    var locale = es_mx_default.a;
    switch (loc) {
      case 'en':
        locale = en_us_default.a;
        break;
      case 'es':
        locale = es_mx_default.a;
        break;
    }

    return Object(preact_min["h"])(
      preact_i18n_esm["a" /* IntlProvider */],
      { definition: locale },
      Object(preact_min["h"])(
        'div',
        { id: 'app' },
        Object(preact_min["h"])(
          home,
          { path: '/', btcHodl: btcHodl, fiatPurchase: fiatPurchase,
            btcPrice: btcPrice, goldPrice: goldPrice,
            updateBtcHodl: this.updateBtcHodl.bind(this),
            updateFiatPurchase: this.updateFiatPurchase.bind(this) },
          Object(preact_min["h"])(
            'button',
            { onClick: function onClick() {
                return _this4.updateLocale('en');
              } },
            'english'
          ),
          '\xA0',
          Object(preact_min["h"])(
            'button',
            { onClick: function onClick() {
                return _this4.updateLocale('es');
              } },
            'espa\xF1ol'
          )
        )
      )
    );
  };

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "Lwtw":
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":"","unitSeparator":"és ","base":{"0":"nulla","1":"egy","2":"kettő","3":"három","4":"négy","5":"öt","6":"hat","7":"hét","8":"nyolc","9":"kilenc","10":"tíz","11":"tizenegy","12":"tizenkettő","13":"tizenhárom","14":"tizennégy","15":"tizenöt","16":"tizenhat","17":"tizenhét","18":"tizennyolc","19":"tizenkilenc","20":"húsz","21":"huszonegy","22":"huszonkettő","23":"huszonhárom","24":"huszonnégy","25":"huszonöt","26":"huszonhat","27":"huszonhét","28":"huszonnyolc","29":"huszonkilenc","30":"harminc","40":"negyven","50":"ötven","60":"hatvan","70":"hetven","80":"nyolcvan","90":"kilencven","100":"száz","200":"kétszáz","300":"háromszáz","400":"négyszáz","500":"ötszáz","600":"hatszáz","700":"hétszáz","800":"nyolcszáz","900":"kilencszáz","1000":"ezer"},"unitExceptions":{"1":"egy"},"units":[{"singular":"száz","useBaseInstead":true,"useBaseException":[1]},{"singular":"ezer","avoidPrefixException":[1]},{"singular":"millió","avoidPrefixException":[1]},{"singular":"milliárd","avoidPrefixException":[1]},{"singular":"-billió","avoidPrefixException":[1]},{"singular":"billiárd","avoidPrefixException":[1]},{"singular":"trillió","avoidPrefixException":[1]},{"singular":"trilliárd","avoidPrefixException":[1]},{"singular":"kvadrillió","avoidPrefixException":[1]},{"singular":"kvadrilliárd","avoidPrefixException":[1]},{"singular":"kvintillió","avoidPrefixException":[1]},{"singular":"kvintilliárd","avoidPrefixException":[1]},{"singular":"szextillió","avoidPrefixException":[1]},{"singular":"szeptillió","avoidPrefixException":[1]},{"singular":"oktillió","avoidPrefixException":[1]},{"singular":"nonillió","avoidPrefixException":[1]}]}

/***/ }),

/***/ "N0i4":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"","base":{"0":"zéro","1":"un","2":"deux","3":"trois","4":"quatre","5":"cinq","6":"six","7":"sept","8":"huit","9":"neuf","10":"dix","11":"onze","12":"douze","13":"treize","14":"quatorze","15":"quinze","16":"seize","17":"dix-sept","18":"dix-huit","19":"dix-neuf","20":"vingt","30":"trente","40":"quarante","50":"cinquante","60":"soixante","70":"soixante-dix","80":"quatre-vingt","90":"quatre-vingt-dix"},"units":[{"singular":"cent","plural":"cents","avoidInNumberPlural":true,"avoidPrefixException":[1]},{"singular":"mille","avoidPrefixException":[1]},{"singular":"million","plural":"millions"},{"singular":"milliard","plural":"milliards"},{"singular":"billion","plural":"billions"},{"singular":"billiard","plural":"billiards"},{"singular":"trillion","plural":"trillions"},{"singular":"trilliard","plural":"trilliards"},{"singular":"quadrillion","plural":"quadrillions"},{"singular":"quadrilliard","plural":"quadrilliards"},{"singular":"quintillion","plural":"quintillions"},{"singular":"quintilliard","plural":"quintilliards"},{"singular":"sextillion","plural":"sextillions"},{"singular":"sextilliard","plural":"sextilliards"},{"singular":"septillion","plural":"septillions"},{"singular":"septilliard","plural":"septilliards"},{"singular":"octillion","plural":"octillions"}],"unitExceptions":{"21":"vingt et un","31":"trente et un","41":"quarante et un","51":"cinquante et un","61":"soixante et un","71":"soixante et onze","72":"soixante-douze","73":"soixante-treize","74":"soixante-quatorze","75":"soixante-quinze","76":"soixante-seize","77":"soixante-dix-sept","78":"soixante-dix-huit","79":"soixante-dix-neuf","80":"quatre-vingts","91":"quatre-vingt-onze","92":"quatre-vingt-douze","93":"quatre-vingt-treize","94":"quatre-vingt-quatorze","95":"quatre-vingt-quinze","96":"quatre-vingt-seize","97":"quatre-vingt-dix-sept","98":"quatre-vingt-dix-huit","99":"quatre-vingt-dix-neuf"}}

/***/ }),

/***/ "Oase":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" e ","unitSeparator":"e ","andWhenTrailing":true,"base":{"0":"zero","1":"um","2":"dois","3":"três","4":"quatro","5":"cinco","6":"seis","7":"sete","8":"oito","9":"nove","10":"dez","11":"onze","12":"doze","13":"treze","14":"catorze","15":"quinze","16":"dezesseis","17":"dezessete","18":"dezoito","19":"dezenove","20":"vinte","30":"trinta","40":"quarenta","50":"cinquenta","60":"sessenta","70":"setenta","80":"oitenta","90":"noventa","100":"cem","200":"duzentos","300":"trezentos","400":"quatrocentos","500":"quinhentos","600":"seiscentos","700":"setecentos","800":"oitocentos","900":"novecentos","1000":"mil"},"unitExceptions":{"1":"um"},"units":[{"singular":"cento","useBaseInstead":true,"useBaseException":[1],"useBaseExceptionWhenNoTrailingNumbers":true,"andException":true},{"singular":"mil","avoidPrefixException":[1],"andException":true},{"singular":"milhão","plural":"milhões"},{"singular":"bilhão","plural":"bilhões"},{"singular":"trilhão","plural":"trilhões"},{"singular":"quadrilhão","plural":"quadrilhão"},{"singular":"quintilhão","plural":"quintilhões"},{"singular":"sextilhão","plural":"sextilhões"},{"singular":"septilhão","plural":"septilhões"},{"singular":"octilhão","plural":"octilhões"},{"singular":"nonilhão","plural":"nonilhões"},{"singular":"decilhão","plural":"decilhões"},{"singular":"undecilhão","plural":"undecilhões"},{"singular":"doudecilhão","plural":"doudecilhões"},{"singular":"tredecilhão","plural":"tredecilhões"}]}

/***/ }),

/***/ "QbsE":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"and ","base":{"0":"zero","1":"one","2":"two","3":"three","4":"four","5":"five","6":"six","7":"seven","8":"eight","9":"nine","10":"ten","11":"eleven","12":"twelve","13":"thirteen","14":"fourteen","15":"fifteen","16":"sixteen","17":"seventeen","18":"eighteen","19":"nineteen","20":"twenty","30":"thirty","40":"forty","50":"fifty","60":"sixty","70":"seventy","80":"eighty","90":"ninety"},"units":["hundred","thousand","million","billion","trillion","quadrillion","quintillion","sextillion","septillion","octillion","nonillion","decillion","undecillion","duodecillion","tredecillion","quattuordecillion","quindecillion"],"unitExceptions":[]}

/***/ }),

/***/ "XJYd":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"","unitSeparator":"","generalSeparator":"","wordSeparator":"","base":{"0":"zero","1":"uno","2":"due","3":"tre","4":"quattro","5":"cinque","6":"sei","7":"sette","8":"otto","9":"nove","10":"dieci","11":"undici","12":"dodici","13":"tredici","14":"quattordici","15":"quindici","16":"sedici","17":"diciassette","18":"diciotto","19":"diciannove","20":"venti","21":"ventuno","23":"ventitré","28":"ventotto","30":"trenta","31":"trentuno","33":"trentatré","38":"trentotto","40":"quaranta","41":"quarantuno","43":"quaranta­tré","48":"quarantotto","50":"cinquanta","51":"cinquantuno","53":"cinquantatré","58":"cinquantotto","60":"sessanta","61":"sessantuno","63":"sessanta­tré","68":"sessantotto","70":"settanta","71":"settantuno","73":"settantatré","78":"settantotto","80":"ottanta","81":"ottantuno","83":"ottantatré","88":"ottantotto","90":"novanta","91":"novantuno","93":"novantatré","98":"novantotto","100":"cento","101":"centuno","108":"centootto","180":"centottanta","201":"duecentuno","301":"tre­cent­uno","401":"quattro­cent­uno","501":"cinque­cent­uno","601":"sei­cent­uno","701":"sette­cent­uno","801":"otto­cent­uno","901":"nove­cent­uno"},"unitExceptions":{"1":"un"},"units":[{"singular":"cento","avoidPrefixException":[1]},{"singular":"mille","plural":"mila","avoidPrefixException":[1]},{"singular":"milione","plural":"milioni"},{"singular":"miliardo","plural":"miliardi"},{"singular":"bilione","plural":"bilioni"},{"singular":"biliardo","plural":"biliardi"},{"singular":"trilione","plural":"trilioni"},{"singular":"triliardo","plural":"triliardi"},{"singular":"quadrilione","plural":"quadrilioni"},{"singular":"quadriliardo","plural":"quadriliardi"}]}

/***/ }),

/***/ "ZNW6":
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":" y ","unitSeparator":"","base":{"0":"cero","1":"uno","2":"dos","3":"tres","4":"cuatro","5":"cinco","6":"seis","7":"siete","8":"ocho","9":"nueve","10":"diez","11":"once","12":"doce","13":"trece","14":"catorce","15":"quince","16":"dieciséis","17":"diecisiete","18":"dieciocho","19":"diecinueve","20":"veinte","21":"veintiuno","22":"veintidós","23":"veintitrés","24":"veinticuatro","25":"veinticinco","26":"veintiséis","27":"veintisiete","28":"veintiocho","29":"veintinueve","30":"treinta","40":"cuarenta","50":"cincuenta","60":"sesenta","70":"setenta","80":"ochenta","90":"noventa","100":"cien","200":"doscientos","300":"trescientos","400":"cuatrocientos","500":"quinientos","600":"seiscientos","700":"setecientos","800":"ochocientos","900":"novecientos","1000":"mil"},"unitExceptions":{"1000000":"un millón","1000000000000":"un billón","1000000000000000000":"un trillón","1000000000000000000000000":"un cuatrillones","1000000000000000000000000000000":"un quintillón","1000000000000000000000000000000000000":"un sextillón","1000000000000000000000000000000000000000000":"un septillón","1000000000000000000000000000000000000000000000000":"un octillón","1000000000000000000000000000000000000000000000000000000":"un nonillón","1000000000000000000000000000000000000000000000000000000000000":"un decillón","1000000000000000000000000000000000000000000000000000000000000000000":"un undecillón","1000000000000000000000000000000000000000000000000000000000000000000000000":"un duodecillón","1000000000000000000000000000000000000000000000000000000000000000000000000000000":"un tredecillón","1000000000000000000000000000000000000000000000000000000000000000000000000000000000000":"un cuatordecillón","1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000":"un quindecillón"},"units":[{"singular":"ciento","useBaseInstead":true,"useBaseException":[1]},{"singular":"mil","avoidPrefixException":[1]},{"singular":"millón","plural":"millones"},{"singular":"billón","plural":"billones"},{"singular":"trillón","plural":"trillones"},{"singular":"cuatrillón","plural":"cuatrillones"},{"singular":"quintillón","plural":"quintillones"},{"singular":"sextillón","plural":"sextillones"},{"singular":"septillón","plural":"septillones"},{"singular":"octillón","plural":"octillones"},{"singular":"nonillón","plural":"nonillones"},{"singular":"decillón","plural":"decillones"},{"singular":"undecillón","plural":"undecillones"},{"singular":"duodecillón","plural":"duodecillones"},{"singular":"tredecillón","plural":"tredecillones"},{"singular":"cuatrodecillón","plural":"cuatrodecillones"},{"singular":"quindecillón","plural":"quindecillones"}]}

/***/ }),

/***/ "aQQq":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"нуль","1":"один","2":"два","3":"три","4":"чотири","5":"п’ять","6":"шість","7":"сім","8":"вісім","9":"дев’ять","10":"десять","11":"одинадцять","12":"дванадцять","13":"тринадцять","14":"чотирнадцять","15":"п’ятнадцять","16":"шістнадцять","17":"сімнадцять","18":"вісімнадцять","19":"дев’ятнадцять","20":"двадцять","30":"тридцять","40":"сорок","50":"п’ятдесят","60":"шістдесят","70":"сімдесят","80":"вісімдесят","90":"дев’яносто","100":"сто","200":"двісті","300":"триста","400":"чотириста","500":"п’ятсот","600":"шістсот","700":"сімсот","800":"вісімсот","900":"дев’ятсот"},"alternativeBase":{"feminine":{"1":"одна","2":"дві"}},"units":[{"useBaseInstead":true,"useBaseException":[]},{"singular":"тисяча","few":"тисячі","plural":"тисяч","useAlternativeBase":"feminine","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"мільйон","few":"мільйони","plural":"мільйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"мільярд","few":"мільярди","plural":"мільярдів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"трильйон","few":"трильйони","plural":"трильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"квадрильйон","few":"квадрильйони","plural":"квадрильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"квінтильйон","few":"квінтильйони","plural":"квінтильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"секстильйон","few":"секстильйони","plural":"секстильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"септілліон","few":"септілліони","plural":"септілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"октілліон","few":"октілліони","plural":"октілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"нонілліон","few":"нонілліони","plural":"нонілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"децілліон","few":"децілліони","plural":"децілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"ундецілліон","few":"ундецілліони","plural":"ундецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"дуодецілліон","few":"дуодецілліони","plural":"дуодецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"тредецілліон","few":"тредецілліони","plural":"тредецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"кватуордецілліон","few":"кватуордецілліони","plural":"кватуордецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"квіндецілліон","few":"квіндецілліони","plural":"квіндецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]}],"unitExceptions":[]}

/***/ }),

/***/ "cF+q":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"and ","base":{"0":"zero","1":"one","2":"two","3":"three","4":"four","5":"five","6":"six","7":"seven","8":"eight","9":"nine","10":"ten","11":"eleven","12":"twelve","13":"thirteen","14":"fourteen","15":"fifteen","16":"sixteen","17":"seventeen","18":"eighteen","19":"nineteen","20":"twenty","30":"thirty","40":"forty","50":"fifty","60":"sixty","70":"seventy","80":"eighty","90":"ninety"},"units":{"2":"hundred","3":"thousand","5":"lakh","7":"crore"},"unitExceptions":[]}

/***/ }),

/***/ "i6oV":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"và ","base":{"0":"không","1":"một","2":"hai","3":"ba","4":"bốn","5":"năm","6":"sáu","7":"bảy","8":"tám","9":"chín","10":"mười","15":"mười lăm","20":"hai mươi","21":"hai mươi mốt","25":"hai mươi lăm","30":"ba mươi","31":"ba mươi mốt","40":"bốn mươi","41":"bốn mươi mốt","45":"bốn mươi lăm","50":"năm mươi","51":"năm mươi mốt","55":"năm mươi lăm","60":"sáu mươi","61":"sáu mươi mốt","65":"sáu mươi lăm","70":"bảy mươi","71":"bảy mươi mốt","75":"bảy mươi lăm","80":"tám mươi","81":"tám mươi mốt","85":"tám mươi lăm","90":"chín mươi","91":"chín mươi mốt","95":"chín mươi lăm"},"units":["trăm","ngàn","triệu","tỷ","nghìn tỷ"],"unitExceptions":[]}

/***/ }),

/***/ "iSAk":
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"nulo","1":"unu","2":"du","3":"tri","4":"kvar","5":"kvin","6":"ses","7":"sep","8":"ok","9":"naŭ","10":"dek","20":"dudek","30":"tridek","40":"kvardek","50":"kvindek","60":"sesdek","70":"sepdek","80":"okdek","90":"naŭdek","100":"cent","200":"ducent","300":"tricent","400":"kvarcent","500":"kvincent","600":"sescent","700":"sepcent","800":"okcent","900":"naŭcent"},"units":[{"useBaseInstead":true,"useBaseException":[]},{"singular":"mil","avoidPrefixException":[1]},{"singular":"miliono","plural":"milionoj","avoidPrefixException":[1]},{"singular":"miliardo","plural":"miliardoj","avoidPrefixException":[1]},{"singular":"biliono","plural":"bilionoj","avoidPrefixException":[1]}],"unitExceptions":[]}

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qqRS":
/***/ (function(module, exports) {

module.exports = {"amount":"amount","mined-gold":"mined gold","millionaire-average":"multimillionaire shares","percenter-wealth":"0.1 percenter shares","intro":{"line-1":"Have you ever wondered if one day you could own some bitcoin?","line-2":"Chances are you can acquire some bitcoin.","line-4":"Fractions of a bitcoin are called satoshis.","explain-satoshis":"One bitcoin is equal to one hundred million satoshis."},"world":{"title":"For each person","intro":"How much bitcoin would you get if it were distributed worldwide?","adult-population":"adult population","bitcoin-supply":"bitcoin supply","bitcoin-for-each-person":"bitcoin for each person","satoshis-for-each-person":"satoshis for each person"},"cash":{"title":"Cash","could-buy-me":"could buy me","description":"What's my bitcoin haul for this cash?"},"bitcoin":{"individual-world-share":"adult shares"},"supply":{"title":"Supply","supply-percentage":"Supplies Comparison","bitcoin-equivalent":"proportional in btc","broad-money":"broad money","millionaire-median":"Millionaire Median","millionaire-average":"Average Millionaire","billionaire-average":"Average Billionaire","percenter-median":"The 1% Median"},"bitcoin-stats":{"total-adults":"Adults","total-wealth":"Total wealth","total-supply":"Total supply","lost-estimate":"Lost estimate","remaining-supply":"Remaining supply","one-bitcoin":"One Bitcoin","100M-sats":"One hundred million Satoshis"},"wealth-pyramid":{"title":"Wealth Pyramid","global-wealth":"Global Wealth"}}

/***/ }),

/***/ "rNh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlProvider; });
/* unused harmony export Localizer */
/* unused harmony export MarkupText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Text; });
/* unused harmony export intl */
/* unused harmony export withText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__("CYb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);



/** Check if an object is not null or undefined
 *	@private
 */
function defined(obj) {
  return obj !== null && obj !== undefined;
}

/** A simpler Object.assign
 *  @private
 */
function assign(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
  return obj;
}

/** Recursively copy keys from `source` to `target`, skipping truthy values already in `target`.
 *	@private
 */
function deepAssign(target, source) {
  var out = assign({}, target);
  for (var i in source) {
    if (source.hasOwnProperty(i)) {
      if (target[i] && source[i] && typeof target[i] === 'object' && typeof source[i] === 'object') {
        out[i] = deepAssign(target[i], source[i]);
      } else {
        out[i] = target[i] || source[i];
      }
    }
  }
  return out;
}

/** select('foo,bar') creates a mapping: `{ foo, bar }`
 *	@private
 */
function select(properties) {
  properties = properties || {};
  if (typeof properties === 'string') {
    properties = properties.split(',');
  }
  if ('join' in properties) {
    var selected = {};
    for (var i = 0; i < properties.length; i++) {
      var val = properties[i].trim();
      if (val) {
        selected[val.split('.').pop()] = val;
      }
    }
    return selected;
  }
  return properties;
}

var URL_FLAG = /[?&#]intl=show/;

/** `<IntlProvider>` is a nestable internationalization definition provider.
 *	It exposes an Intl scope & definition into the tree,
 *	making them available to descendant components.
 *
 *	> **Note:** When nested, gives precedence to keys higher up the tree!
 *	> This means lower-level components can set their defaults by wrapping themselves
 *	> in an `<IntlProvider>`, but still remain localizable by their parent components.
 *
 *	@name IntlProvider
 *	@param props
 *	@param {String} [props.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param {Boolean} [props.mark=false]		If `true`, all `<Text>` elements will be shown with a red/green background indicating whether they have valid Intl keys.
 *	@param {Object} [props.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 *
 *	@example
 *	// generally imported from a JSON file:
 *	let definition = {
 *		foo: 'Le Feux'
 *	};
 *
 *	<IntlProvider scope="weather" definition={definition}>
 *		<Text key="foo">The Foo</Text>
 *	</IntlProvider>
 *
 *	// This will render the text:
 *	"Le Feux"
 */
var IntlProvider = /*@__PURE__*/function (Component) {
  function IntlProvider() {
    Component.apply(this, arguments);
  }

  if (Component) IntlProvider.__proto__ = Component;
  IntlProvider.prototype = Object.create(Component && Component.prototype);
  IntlProvider.prototype.constructor = IntlProvider;

  IntlProvider.prototype.getChildContext = function getChildContext() {
    var ref = this.props;
    var scope = ref.scope;
    var definition = ref.definition;
    var mark = ref.mark;
    var intl = assign({}, this.context.intl || {});

    // set active scope for the tree if given
    if (scope) {
      intl.scope = scope;
    }

    // merge definition into current with lower precedence
    if (definition) {
      intl.dictionary = deepAssign(intl.dictionary || {}, definition);
    }

    if (mark || typeof location !== 'undefined' && String(location).match(URL_FLAG)) {
      intl.mark = true;
    }

    return { intl: intl };
  };

  IntlProvider.prototype.render = function render(ref) {
    var children = ref.children;

    return children && children[0] || null;
  };

  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/**
 * Higher-order function that creates an `<IntlProvider />` wrapper component for the given component.  It
 * takes two forms depending on how many arguments it's given:
 * It can take a functional form like:
 * intl(ComponentToWrap, options)
 *
 * or it can take an annotation form like:
 * @intl(options)
 * class ComponentToWrap extends Component {}
 *
 *	@param {Component or Object} args[0] If there are two arguments, the first argument is the Component to wrap in `<IntlProvider/>`. If there is just one argument, this is the options object to pass as `props` to `<IntlProvider/>`. See the definition of the options param below for details.
 *	@param {Object} options If there are two arguments, the second argument is Passed as `props` to `<IntlProvider />`
 *	@param [options.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param [options.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 */
function intl(Child, options) {
  if (arguments.length < 2) {
    options = Child;
    return function (Child) {
      return intl(Child, options);
    };
  }
  function IntlProviderWrapper(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(IntlProvider, options || {}, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, props));
  }

  IntlProviderWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
    return Child;
  };
  return IntlProviderWrapper;
}

var EMPTY = {};

/** Populate {{template.fields}} within a given string.
 *
 *	@private
 *	@param {String} template	The string containing fields to be resolved
 *	@param {Object} [fields={}]	Optionally nested object of fields, referencable from `template`.
 *	@example
 *		template('foo{{bar}}', { bar:'baz' }) === 'foobaz'
 */
function template(template, fields, scope, dictionary) {
  return template && template.replace(/\{\{([\w.-]+)\}\}/g, replacer.bind(null, fields || EMPTY, scope, dictionary));
}

/** Replacement callback for injecting fields into a String
 *	@private
 */
function replacer(currentFields, scope, dictionary, s, field) {
  var parts = field.split('.'),
      v = currentFields;
  for (var i = 0; i < parts.length; i++) {
    v = v[parts[i]];
    if (v == null) {
      return '';
    } // eslint-disable-line eqeqeq

    //allow field values to be <Text /> nodes
    if (v && v.nodeName === Text) {
      return translate(v.attributes.id, scope, dictionary, v.attributes.fields, v.attributes.plural, v.attributes.fallback);
    }
  }
  // allow for recursive {{config.xx}} references:
  if (typeof v === 'string' && v.match(/\{\{/)) {
    v = template(v, currentFields);
  }
  return v;
}

/** Attempts to look up a translated value from a given dictionary.
 *  Also supports json templating using the format: {{variable}}
 *	Falls back to default text.
 *
 *	@private
 *	@param {String} id				Intl field name/id (subject to scope)
 *	@param {String} [scope='']		Scope, which prefixes `id` with `${scope}.`
 *	@param {Object} dictionary		A nested object containing translations
 *	@param {Object} [fields={}]		Template fields for use by translated strings
 *	@param {Number} [plural]		Indicates a quantity, used to trigger pluralization
 *	@param {String|Array} [fallback]	Text to return if no translation is found
 *	@returns {String} translated
 */
function translate(id, scope, dictionary, fields, plural, fallback) {
  if (scope) {
    id = scope + '.' + id;
  }

  var value = dictionary && __WEBPACK_IMPORTED_MODULE_1_dlv___default()(dictionary, id);

  // plural forms:
  // key: ['plural', 'singular']
  // key: { none, one, many }
  // key: { zero, one, other }
  // key: { singular, plural }
  if ((plural || plural === 0) && value && typeof value === 'object') {
    if (value.splice) {
      value = value[plural] || value[0];
    } else if (plural === 0 && defined(value.none || value.zero)) {
      value = value.none || value.zero;
    } else if (plural === 1 && defined(value.one || value.singular)) {
      value = value.one || value.singular;
    } else {
      value = value.some || value.many || value.plural || value.other || value;
    }
  }

  return value && template(value, fields, scope, dictionary) || fallback || null;
}

/** Highlight/colorize the i18n'd node if `mark` is set on `intl` in context.  If not, just returns `value`
 *
 *	@private
 *	@param {String|VNode} value	The l10n'd text/vnode to highlight or pass through
 *	@param {string} id	The key used to lookup the value in the intl dictionary
 */
function HighlightI18N(ref, ref$1) {
  var value = ref.value;
  var id = ref.id;
  var intl = ref$1.intl;

  if (intl && intl.mark) {
    var dictionaryKey = "dictionary" + (intl && intl.scope ? "." + intl.scope : '') + "." + id;
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('mark', {
      style: 'background: ' + (value ? __WEBPACK_IMPORTED_MODULE_1_dlv___default()(intl, dictionaryKey) ? 'rgba(119,231,117,.5)' // Green = this string is fully internationalized
      : 'rgba(229,226,41,.5)' // Yellow = this string does not have a value in the dictionary, but it has a fallback value
      : 'rgba(228,147,51,.5)' // Red = this string has no value and no fallback
      ),
      title: id
    }, value);
  }

  return value;
}

/** `<Text>` renders internationalized text.
 *	It attempts to look up translated values from a dictionary in context.
 *
 *	Template strings can contain `{{field}}` placeholders,
 *	which injects values from the `fields` prop.
 *
 *	When string lookup fails, renders its children as fallback text.
 *
 *	@param {Object} props				props
 *	@param {String} props.id			Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {Object} [props.fields={}]	Values to inject into template `{{fields}}`.  Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number} [props.plural]		Integer "count", used to select plural forms
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<Text id="foo">The Foo</Text>
 *	// ..produces the text:
 *	"The Foo"
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux {{bar}}' }}>
 *		<Text id="foo" fields={{ bar: 'BEAR' }}>The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux BEAR"
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le Feux' }}>
 *		<Text id="foo">The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux"
 */
function Text(ref, ref$1) {
  var id = ref.id;
  var children = ref.children;
  var plural = ref.plural;
  var fields = ref.fields;
  var intl = ref$1.intl;

  var fallback = children && children[0];

  var value = translate(id, intl && intl.scope, intl && intl.dictionary, fields, plural, fallback);

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(HighlightI18N, { id: id, value: value });
}

/** Translates the property values in an Object, returning a copy.
 *	**Note:** By default, `String` keys will be treated as Intl ID's.
 *	Pass `true` to return an Object containing *only* translated
 *	values where the prop is a <Text /> node.
 *
 *	@private
 *	@param {Object} props	An object with values to translate
 *	@param {Object} intl	An intl context object (eg: `context.intl`)
 *	@param {Boolean} [onlyTextNodes=false]	Only process `<Text />` values
 *	@returns {Object} translatedProps
 */
function translateMapping(props, intl, onlyTextNodes) {
  var out = {};
  intl = intl || {};
  props = select(props);
  for (var name in props) {
    if (props.hasOwnProperty(name) && props[name]) {
      var def = props[name];

      // if onlyTextNodes=true, skip any props that aren't <Text /> vnodes
      if (!onlyTextNodes && typeof def === 'string') {
        out[name] = translate(def, intl.scope, intl.dictionary);
      } else if (def.nodeName === Text) {
        // it's a <Text />, just grab its props:
        var c = def.children;
        def = assign({
          //no fallback if there are no children.  Return first child if there is only 1, or array of children if there are more than one
          fallback: c.length && (c.length === 1 ? c[0] : c)
        }, def.attributes);
        out[name] = translate(def.id, intl.scope, intl.dictionary, def.fields, def.plural, def.fallback);
      }
    }
  }
  return out;
}

/** `<Localizer />` is a Compositional Component.
 *	It "renders" out any `<Text />` values in its child's props.
 *
 *	@name Localizer
 *	@param {Object} props
 *	@param {Object} props.children	Child components with props to localize.
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *	@example
 *	<Localizer>
 *		<input placeholder={<Text id="username.placeholder" />} />
 *	</Localizer>
 *	// produces:
 *	<input placeholder="foo" />
 *
 *	@example
 *	<Localizer>
 *		<abbr title={<Text id="oss-title">Open Source Software</Text>}>
 *			<Text id="oss">OSS</Text>
 *		</abbr>
 *	</Localizer>
 *	// produces:
 *	<abbr title="Open Source Software">OSS</abbr>
 */
function Localizer(ref, ref$1) {
  var children = ref.children;
  var intl = ref$1.intl;

  var child = children && children[0];
  return child && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(child, translateMapping(child.attributes, intl, true));
}

/* eslint-disable react/no-danger */

/** `<MarkupText>` is just like {@link Text} but it can also contain html markup in rendered strings.  It wraps its contents in a `<span>` tag.
 *
 *	@param {Object} props				props
 *	@param {String} props.id			Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {Object} [props.fields={}]	Values to inject into template `{{fields}}`.  Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number} [props.plural]		Integer "count", used to select plural forms
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<MarkupText id="foo"><b>The Foo</b></MarkupText>
 *	// ..produces the vnode:
 *	<span><b>The Foo</b></span>
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux <b>{{bar}}</b>' }}>
 *		<MarkupText id="foo" fields={{ bar: 'BEAR' }}>The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le Feux <b>BEAR</b></span>
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le <a href="http://foo.com">Feux</a>' }}>
 *		<MarkupText id="foo">The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le <a href="http://foo.com">Feux</a></span>
 *
 *	@example
 *	// renders nothing if there is no key match and no fallback
 *	<div><MarkupText /></div>
 *	// ..produces the vnode:
 *	<div/>
 */
function MarkupText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Localizer, null, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Html, { html: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Text, props), id: props.id }));
}

function Html(ref) {
  var html = ref.html;
  var id = ref.id;

  var value = !html ? html : typeof html === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { dangerouslySetInnerHTML: { __html: html } }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', null, html);
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(HighlightI18N, { id: id, value: value });
}

/** `@withText()` is a Higher Order Component, often used as a decorator.
 *
 *	It wraps a child component and passes it translations
 *	based on a mapping to the dictionary & scope in context.
 *
 *	@param {Object|Function|String} mapping		Maps prop names to intl keys (or `<Text>` nodes).
 *
 *	@example @withText({
 *		placeholder: 'user.placeholder'
 *	})
 *	class Foo {
 *		// now the `placeholder` prop is our localized String:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText({
 *		placeholder: <Text id="user.placeholder">fallback text</Text>
 *	})
 *	class Foo {
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText('user.placeholder')
 *	class Foo {
 *		// for Strings/Arrays, the last path segment becomes the prop name:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example <caption>Works with functional components, too</caption>
 *	const Foo = withText('user.placeholder')( props =>
 *		<input placeholder={props.placeholder} />
 *	)
 *
 * 	@example <caption>getWrappedComponent() returns wrapped child Component</caption>
 *	const Foo = () => <div/>;
 *	const WrappedFoo = withText('user.placeholer')(Foo);
 *	WrappedFoo.getWrappedComponent() === Foo; // true
 */
function withText(mapping) {
  return function withTextWrapper(Child) {
    function WithTextWrapper(props, context) {
      var map = typeof mapping === 'function' ? mapping(props, context) : mapping;
      var translations = translateMapping(map, context.intl);
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, assign(assign({}, props), translations));
    }

    WithTextWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
      return Child;
    };
    return WithTextWrapper;
  };
}

intl.intl = intl;
intl.IntlProvider = IntlProvider;
intl.Text = Text;
intl.MarkupText = MarkupText;
intl.Localizer = Localizer;
intl.withText = withText;

/* unused harmony default export */ var _unused_webpack_default_export = (intl);

//# sourceMappingURL=preact-i18n.esm.js.map

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.59ca9.js